/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Cite API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ScoringOptionSelection = {
    Single: 'Single',
    Multiple: 'Multiple',
    None: 'None'
} as const;
export type ScoringOptionSelection = typeof ScoringOptionSelection[keyof typeof ScoringOptionSelection];

